export default "__VITE_ASSET__C6KX6wfS__"